import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSiteContent } from "@/context/SiteContentContext";
import ThemeCustomizer from "@/components/ThemeCustomizer";

export default function Footer() {
    const { user } = useAuth();
    const { content } = useSiteContent();
    const isApproved = user && user !== false && (user.role === "admin" || user.status === "approved");

    return (
        <footer className="bg-slate-900 text-slate-400 mt-24" data-testid="footer">
            <div className="max-w-[1440px] mx-auto px-4 py-12 grid md:grid-cols-4 gap-8">
                <div>
                    <div className="flex flex-col items-start gap-2 mb-4" data-testid="footer-brand">
                        {content.logo_url && (
                            <img
                                src={content.logo_url}
                                alt={content.brand_name}
                                className="object-contain object-left w-auto max-w-[240px]"
                                style={{ height: `${content.footer_logo_size || 36}px` }}
                                data-testid="footer-logo-image"
                            />
                        )}
                        <span className="font-display font-black text-white text-lg uppercase" data-testid="footer-brand-name">
                            {content.brand_name}
                        </span>
                    </div>
                    <p className="text-sm leading-relaxed text-slate-400">
                        {content.footer_tagline}
                    </p>
                </div>
                <div>
                    <div className="label-kicker mb-3 text-slate-500">Catalog</div>
                    <ul className="space-y-1.5 text-sm">
                        {isApproved ? (
                            <>
                                <li><Link to="/catalog" className="hover:text-white">All Categories</Link></li>
                                <li><Link to="/new" className="hover:text-white">New Products</Link></li>
                                <li><Link to="/cart" className="hover:text-white">Basket</Link></li>
                            </>
                        ) : (
                            <li><Link to="/login" className="hover:text-white">Log in to browse</Link></li>
                        )}
                    </ul>
                </div>
                <div>
                    <div className="label-kicker mb-3 text-slate-500">Account</div>
                    <ul className="space-y-1.5 text-sm">
                        <li><Link to="/login" className="hover:text-white">Log in</Link></li>
                        <li><Link to="/register" className="hover:text-white">Request access</Link></li>
                        <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact-link">Contact &amp; Location</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="label-kicker mb-3 text-slate-500">Info</div>
                    <ul className="space-y-1.5 text-sm">
                        <li className="font-mono text-xs pt-1">
                            © {new Date().getFullYear()} {content.brand_name}
                        </li>
                        <li className="font-mono text-xs text-slate-500">
                            Admin-managed catalog platform
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-slate-800">
                <div className="max-w-[1440px] mx-auto px-4 py-4 flex flex-wrap items-center justify-center gap-4">
                    <span className="text-xs font-mono text-slate-500 uppercase tracking-widest">
                        {content.footer_copyright}
                    </span>
                    {user && user !== false && user.role === "admin" && (
                        <ThemeCustomizer adminOnly={true} isAdmin={true} />
                    )}
                </div>
            </div>
        </footer>
    );
}
